/*
Copyright (c) 2018 Ady Levy
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import LocalLaundryServiceIcon from '@material-ui/icons/LocalLaundryService';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
// import 'babel-polyfill';
// import fetch from 'cross-fetch';
const config = require('../../config.json');


const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
});

class TestButtonWithConfirmation extends Component {
  state = {
    showDialog: false,
    showDialog2: false,
    loading: false,
    msg: ''
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, showDialog2: false});
  };
  
  handleConfirm = (event) => {
    event.preventDefault();
    this.setState({ loading: true, showDialog: false });
    const { record } = this.props;
    let data = {
      userId: localStorage.getItem('email'),
      amount: 0,
      machineId: record.code,
      priceId: 0,
      initTime: Date.now(),
      tech: localStorage.getItem('email')
    }
    return fetch(config.API_URL + "/payments/payment-init", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return res.json();
    })
    .then(mydata => {
      console.log("Informacion", mydata);
      try {
        let _trId = this.props.record.code;
        setTimeout(this.check_transaction(_trId, 1), 8000);
      } catch (e) {
        console.log(e);
        this.setState({
          showDialog2: true,
          msg: e,
          loading: false
        })
      }
    })
    .catch(err => {
      console.log(err);
      this.setState({
        showDialog2: true,
        msg: "Init " + err.toString(),
        loading: false
      })
    })
  };

  check_transaction = (machine, intento=0) => {
    let data = {
      userId: localStorage.getItem('email'),
      machineId: machine
    }
    console.log("Información a chequear", data);
    if (machine === undefined) {
      let _msg = "Check 1. No se realizó correctamente el proceso.";
      const hora = new Date();
      _msg += "\n\nMáquina: " + this.props.record.code + "\nHora: " + hora.toUTCString();
      this.setState({
        loading: false,
        showDialog2: true,
        msg: _msg
      })
      return;
    }
    console.log(data, intento);
    if (intento > 8) {
      let _msg = "Check 2. No se realizó correctamente el proceso.";
      const hora = new Date();
      _msg += "\n\nMáquina: " + this.props.record.code + "\nHora: " + hora.toUTCString();
      this.setState({
        loading: false,
        showDialog2: true,
        msg: _msg
      })
      return;
    }
    return fetch(config.API_URL + "/payments/payment-check-tech", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return res.status;
    })
    .then(myStatusCode => {
      console.log("Data recibida", myStatusCode);
      if (![200, 201, 203, 500].includes(myStatusCode)) {
        setTimeout(this.check_transaction(machine, intento + 1), 8000);
      } else {
        let _msg = "";
        if (myStatusCode === 201) {
          _msg = "Se ha creado con éxito la transacción."
        } else if (myStatusCode === 200) {
          _msg = "No se pudo completar la operación. La transacción ha sido cancelada."
        } else if (myStatusCode === 203) {
          _msg = "No se pudo completar la operación. La transacción no fue creada."
        } else if (myStatusCode === 500) {
          _msg = "No se pudo completar la operación. Hubo un error en el servidor."
        } else {
          _msg = "Llego un código incorrecto: " + myStatusCode.toString();
        }
        try {
          const hora = new Date();
          _msg += "\n\nMáquina: " + this.props.record.code + "\nHora: " + hora.toUTCString();
        } catch (e) {
          console.log(e);
        }
        this.setState({
          loading: false,
          showDialog2: true,
          msg: _msg
        })
      }
    })
    .catch(err => {
      console.log(err);
      let _msg = "Check " + err.toString();
      try {
        const hora = new Date();
        _msg += "\n\nMáquina: " + this.props.record.code + "\nHora: " + hora.toUTCString();
      } catch (e) {
      }
      this.setState({
        showDialog2: true,
        msg: _msg,
        loading: false
      })
    })
  }

  render() {
    const { showDialog, loading, msg, showDialog2} = this.state;
    const { classes = {}, className } = this.props;
    return (
      <Fragment>
        <Button disabled={loading} onClick={this.handleClick} label="Probar máquina" className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
          <div style={{display: "flex", flexDirection: "row"}}>
            {(!loading) ? <LocalLaundryServiceIcon />
              : <CircularProgress style={{marginLeft: '2%', width: "30px", height: "30px"}}/>
            }
          </div>
        </Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="¿Estás seguro de probar la máquina?">
          <DialogTitle>¿Estás seguro de probar la máquina?</DialogTitle>
          <DialogContent>
            <div>
              Tus acciones serán registradas
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleConfirm} label="Probar máquina" className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
              <LocalLaundryServiceIcon />
            </Button>
            <Button label="Cancelar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog2} onClose={this.handleCloseClick} aria-label="Información de la transacción" style={{"white-space": "pre-line"}}>
          <DialogTitle>Información</DialogTitle>
          <DialogContent>
            <div>
              {msg}
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

TestButtonWithConfirmation.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool
};

TestButtonWithConfirmation.defaultProps = {
  redirect: 'list',
  undoable: true
};

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete }
  ),
  translate,
  withStyles(styles)
)(TestButtonWithConfirmation);